/* eslint-disable jsx-a11y/anchor-is-valid */
import { useLazyQuery } from '@apollo/client'
import { useState, useEffect } from 'react'
import { Row, Col } from 'react-bootstrap'
import { GET_PRODUCT_DETAILS } from '../../../../../utils/GraphQLAPI'
import { StepProps } from '../InterfaceSalesChannelModal'
import ProductDetails from './ProductDetails'
import Dropdown from '../../../../sharedComponent/Dropdown/Dropdown'

const ProductInfo = ({ data, updateData, hasError, formik, hasFieldError, method }: StepProps) => {
  const [commodity, setCommodity] = useState<any>()
  const [customerType, setCustomerType] = useState<any>()
  const [utilities, setUtilities] = useState<any>()
  const [productFieldsState, setProductFieldsState] = useState<any>('')

  useEffect(() => {
    if (method === 'edit') {
      setProductFieldsState('product-fields-disabled')
    }
    getProductDetails()
  }, [formik.values.productNameId])
  //to get the product setup values to
  const [getProductDetails] = useLazyQuery(GET_PRODUCT_DETAILS, {
    onCompleted: (productData) => {
      setUtilities(productData?.getProductDetail[1]?.names)
      setCommodity(productData?.getProductDetail[0]?.names)
      setCustomerType(productData?.getProductDetail[4]?.names)
    },
    fetchPolicy: 'network-only',
  })

  const handleSelectedItem = (e: any, name: any) => {
    if (e.value.length > 0) {
      formik.setFieldValue(name, e.label)
      formik.setFieldValue(`${name}Id`, e.value)
    } else {
      formik.setFieldValue(name, '')
      formik.setFieldValue(`${name}Id`, null)
    }
  }

  return (
    <div className={'pb-5 ' + productFieldsState} data-kt-stepper-element='content'>
      <div className='w-100'>
        <div className='fv-row mb-9'>
          <label className='d-flex align-items-center fs-4 fw-bold lh-1'>
            <h4>Assign Products</h4>
          </label>
        </div>
        <div className=' hover-scroll-overlay-y' style={{ paddingRight: '2%' }}>
          <Row className='mb-5 d-flex align-items-end  no-gutters noPadding'>
            <Col sm={6} md={6} className='mr-0 ml-0 pb-5'>
              <label className='d-flex align-items-center mb-2'>
                <span className='fs-6 fw-semibold lh-23px'>Utility </span>
              </label>
              <Dropdown
                fieldName='utility'
                optionList={utilities}
                handleSelectedItem={handleSelectedItem}
                formik={formik}
              />
            </Col>
            <Col sm={6} md={6} className='mr-0 ml-0 pb-5'>
              <label className='d-flex align-items-center mb-2'>
                <span className='fs-6 fw-semibold lh-23px'>Commodity</span>
              </label>

              <Dropdown
                fieldName='commodity'
                optionList={commodity}
                handleSelectedItem={handleSelectedItem}
                formik={formik}
              />
            </Col>
          </Row>
          <Row className='mb-5 d-flex align-items-end mt-5 no-gutters noPadding'>
            <Col sm={6} md={6} className='mr-0 ml-0 pb-5'>
              <label className='d-flex align-items-center mb-2'>
                <span className='fs-6 fw-semibold lh-23px'>Customer Type</span>
              </label>
              <Dropdown
                fieldName='customerType'
                optionList={customerType}
                handleSelectedItem={handleSelectedItem}
                formik={formik}
              />
            </Col>
          </Row>
          <Row className='mb-5 d-flex align-items-end mt-5 no-gutters noPadding'>
            <ProductDetails
              isEdit={false}
              formik={formik}
              salesDatas={null}
              salesProducts={null}
              label='Choose Products'
            />
          </Row>
        </div>
      </div>
    </div>
  )
}

export { ProductInfo }
